import { ILicenseListItem } from '@cbgms/api'
import { LicenseType } from '@carsys/enums/license-type'
import HaynesCustomerDataSummary from './HaynesProCustomerDataSummary'

const LicenseExtensionCell = (p: { content: ILicenseListItem }) => {
  switch (p.content.Distributor.LicenseType) {
    case LicenseType.HaynesPro:
      return p.content.License?.LicenseExtension?.HaynesCustomer ? (
        <HaynesCustomerDataSummary
          haynesCustomer={p.content.License?.LicenseExtension?.HaynesCustomer}
          licenses={p.content.License?.LicenseExtension?.HaynesLicenses}
          inactiveLicenses={p.content.License?.LicenseExtension?.HaynesInactiveLicenses}
        />
      ) : null
  }
  return null
}

export default LicenseExtensionCell
